import script from "./DaytourTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DaytourTable.vue?vue&type=script&setup=true&lang=js"

import "./DaytourTable.vue?vue&type=style&index=0&id=625122a2&lang=css"

const __exports__ = script;

export default __exports__